import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { FuseConfirmDialogModule } from '@fuse/components';

import { reducer } from './reducer';
import { LoginStoreEffects } from './effects';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature('login', reducer),
        EffectsModule.forFeature([LoginStoreEffects]),

        FuseConfirmDialogModule,
    ],
    providers: [],
})
export class LoginStoreModule {}
